
import React from "react";
import { Link, NavLink } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import Cookies from "universal-cookie";
const cookies = new Cookies();
class DemoNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.weddingRef = React.createRef();
    this.otherRef = React.createRef();
    this.packageRef = React.createRef();
    this.accessoriesRef = React.createRef();
    this.blankRef = React.createRef();
    this.state = {
      collapseClasses: "",
      collapseOpen: false,
      categories: [],
      accessoriesCategories: [],
      giftItemsCategory: [],
      otherCategory: [],
      package: [],
      megaWeddingOpen: false,
      megaOtherOpen: false,
      megaPackageOpen: false,
      megaAccessoriesOpen: false,
      megaBlankOpen: false
    };
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.loadCategories();
    this.loadAccessoriesCategories();
    this.loadgiftItemsCategory();
    this.loadOtherCardCategory();
    this.loadPackage();
    //  let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    // headroom.init();
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    // If click is outside ALL menu refs, then close
    if (
      (!this.weddingRef.current || !this.weddingRef.current.contains(event.target)) &&
      (!this.otherRef.current || !this.otherRef.current.contains(event.target)) &&
      (!this.packageRef.current || !this.packageRef.current.contains(event.target)) &&
      (!this.accessoriesRef.current || !this.accessoriesRef.current.contains(event.target)) &&
      (!this.blankRef.current || !this.blankRef.current.contains(event.target))
    ) {
      this.setState({
        megaWeddingOpen: false,
        megaOtherOpen: false,
        megaPackageOpen: false,
        megaAccessoriesOpen: false,
        megaBlankOpen: false
      });
    }
  };

  toggleMegaWedding = () => {
    this.setState(prev => ({
      megaWeddingOpen: !prev.megaWeddingOpen,
      megaOtherOpen: false,
      megaPackageOpen: false,
      megaAccessoriesOpen: false,
      megaBlankOpen: false
    }));
  };

  toggleMegaOther = () => {
    this.setState(prev => ({
      megaWeddingOpen: false,
      megaOtherOpen: !prev.megaOtherOpen,
      megaPackageOpen: false,
      megaAccessoriesOpen: false,
      megaBlankOpen: false
    }));
  };

  toggleMegaPackage = () => {
    this.setState(prev => ({
      megaWeddingOpen: false,
      megaOtherOpen: false,
      megaPackageOpen: !prev.megaPackageOpen,
      megaAccessoriesOpen: false,
      megaBlankOpen: false
    }));
  };

  toggleMegaAccessories = () => {
    this.setState(prev => ({
      megaWeddingOpen: false,
      megaOtherOpen: false,
      megaPackageOpen: false,
      megaAccessoriesOpen: !prev.megaAccessoriesOpen,
      megaBlankOpen: false
    }));
  };

  toggleMegaBlank = () => {
    this.setState(prev => ({
      megaWeddingOpen: false,
      megaOtherOpen: false,
      megaPackageOpen: false,
      megaAccessoriesOpen: false,
      megaBlankOpen: !prev.megaBlankOpen
    }));
  };
  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out",
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: "",
    });
  };

  loadPackage = () => {
    fetch('../API/weddingPackage.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item) => {
          item.checked = false;
        })
        this.state.package = tempData
        this.setState({
          package: this.state.package
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  loadCategories = () => {
    fetch('../API/categories.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item) => {
          item.checked = false;
        })
        this.state.categories = tempData
        this.setState({
          categories: this.state.categories
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  loadAccessoriesCategories = () => {
    fetch('../API/accessoriesCategory.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item) => {
          item.checked = false;
        })
        this.state.accessoriesCategories = tempData
        this.setState({
          accessoriesCategories: this.state.accessoriesCategories
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  loadgiftItemsCategory = () => {
    fetch('../API/giftItemsCategory.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item) => {
          item.checked = false;
        })
        this.state.giftItemsCategory = tempData
        this.setState({
          giftItemsCategory: this.state.giftItemsCategory
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  loadOtherCardCategory = () => {
    fetch('../API/categoriesOtherCard.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item) => {
          item.checked = false;
        })
        this.state.otherCategory = tempData
        this.setState({
          otherCategory: this.state.otherCategory
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  goToDetails = (id, type) => {
    if (type === 'product') {
      window.location = '/product-category/' + id
    }
    if (type === 'accessories') {
      window.location = '/accessories-category/' + id
    }
    if (type === 'giftitems') {
      window.location = '/giftitems-category/' + id
    }
    if (type === 'othercard') {
      window.location = '/othercard-category/' + id
    }
    if (type === 'package') {
      window.location = '/package/' + id
    }
  }
  render() {
    let checkMypackage = false
    if (localStorage.getItem('porinoyMyPackage') && localStorage.getItem('porinoyMyPackage') !== '' && localStorage.getItem('porinoyMyPackage') !== null) {
      checkMypackage = true
    }
   // alert(window.location.hostname)
    const baseUrl =
      window.location.protocol + "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port + "/" : "/");

    return (
      <>
        <div id="topBar" className="topBar">
          <Container fluid className="h-100">
            <Row className="h-100 align-items-center">
              <Col className="col-lg-4 col-xl-4 col-md-4 col-12 text-center text-lg-left text-xl-left text-md-left" >
                Call us now: +91-9832888069
              </Col>
              {/* <Col className="col-4 text-center d-none d-md-block d-lg-block d-xl-block">
                WELCOME TO PORINOY!
              </Col> */}
              <Col className="col-8 text-right d-none  d-lg-block d-xl-block">
                <ul className="topbar-nav m-0">
                  <li class="nav-item d-inline-block">
                    <NavLink to="/about-us">About Us</NavLink>
                  </li>
                  <li class="nav-item d-inline-block">
                    <NavLink to="/teams">Teams</NavLink>
                  </li>
                  <li class="nav-item d-inline-block">
                    <NavLink to="/testimonials">Testimonials</NavLink>
                  </li>
                  <li class="nav-item d-inline-block">
                    <NavLink to="/stories">Stories</NavLink>
                  </li>
                  <li class="nav-item d-inline-block">
                    <NavLink to="/contact-us">Contact Us</NavLink>
                  </li>
                </ul>


              </Col>
            </Row>
          </Container>

        </div>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container fluid>
              <NavbarBrand className="mr-lg-5 position-relative  d-flex align-items-center justify-content-center" to="/" tag={Link}>
                <span className="logoRound">
                  <img
                    alt="..."
                    src={baseUrl + "images/logo.png"}
                  />
                </span>

              </NavbarBrand>
              <button className="navbar-toggler float-right" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses + " justify-content-end"}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="..."
                          src={baseUrl + "images/logo.png"}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                <Nav className="align-items-lg-center ml-lg-auto main-nav" navbar>
                  <NavItem>
                    <NavLink exact to="/">Home</NavLink>
                  </NavItem>
                  <NavItem className="d-block d-lg-none d-xl-none">
                    <NavLink to="/about-us">About Us</NavLink>
                  </NavItem>
                  <NavItem className="d-block d-lg-none d-xl-none">
                    <NavLink to="/teams">Teams</NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink to="/products">Collection</NavLink>
                  </NavItem> */}
                  <div ref={this.weddingRef} className="mega-menu-wrapper">
                    <UncontrolledDropdown
                      direction="down"
                      nav>
                      <DropdownToggle
                        onClick={() => this.toggleMegaWedding()}
                        className="px-0"
                        caret
                        color="primary"
                        nav>
                        <span className="nav-link-inner--text">Wedding Cards </span>
                      </DropdownToggle>
                      <div
                        className={`mega-menu p-4 shadow-lg ${this.state.megaWeddingOpen ? "show" : ""}`}
                      >
                        <Container>
                          <Row>
                            <div className="col-12">
                              <h3 className="text-capitalize">Wedding Cards</h3>
                            </div>
                            {this.state.categories.map((item, index) => (
                              <Col md="3" className="text-center mb-3 cursor-pointer" key={index} onClick={() => this.goToDetails(item.id, 'product')}>
                                <img
                                  src={baseUrl + item.thumb[0] || ""}
                                  alt={item.name}
                                  className="img-fluid rounded mb-2"
                                />
                                <h6 className="text-capitalize">{item.name}</h6>
                              </Col>
                            ))}
                          </Row>

                        </Container>

                      </div>

                    </UncontrolledDropdown>
                  </div>
                  <div ref={this.otherRef} className="mega-menu-wrapper">
                    <UncontrolledDropdown
                      direction="down"
                      nav>
                      <DropdownToggle
                        onClick={() => this.toggleMegaOther()}
                        className="px-0"
                        caret
                        color="primary"
                        nav>
                        <span className="nav-link-inner--text">Baby</span>
                      </DropdownToggle>
                      <div
                        className={`mega-menu p-4 shadow-lg ${this.state.megaOtherOpen ? "show" : ""}`}
                      >
                        <Container>
                          <Row>
                            <div className="col-12">
                              <h3 className="text-capitalize">Baby</h3>
                            </div>
                            {this.state.otherCategory.map((item, index) => (
                              <Col md="3" className="text-center mb-3 cursor-pointer" key={index} onClick={() => this.goToDetails(item.id, 'othercard')}>
                                <img
                                  src={baseUrl + item.thumb[0] || ""}
                                  alt={item.name}
                                  className="img-fluid rounded mb-2"
                                />
                                <h6 className="text-capitalize">{item.name}</h6>
                              </Col>
                            ))}
                          </Row>

                        </Container>

                      </div>

                    </UncontrolledDropdown>
                  </div>
                  <div ref={this.packageRef} className="mega-menu-wrapper">
                    <UncontrolledDropdown
                      direction="down"
                      nav>
                      <DropdownToggle
                        onClick={() => this.toggleMegaPackage()}
                        className="px-0"
                        caret
                        color="primary"
                        nav>
                        <span className="nav-link-inner--text">Package</span>
                      </DropdownToggle>
                      <div
                        className={`mega-menu p-4 shadow-lg ${this.state.megaPackageOpen ? "show" : ""}`}
                      >

                        <Container fluid>
                          <Row>
                            <div className="col-12">
                              <h3 className="text-capitalize">Package</h3>
                            </div>
                            {this.state.package.map((item, index) => (
                              <Col md="3" className="text-center mb-3 cursor-pointer" key={index} onClick={() => this.goToDetails(item.id, 'package')}>
                                <img
                                  src={baseUrl + item.thumb[0] || ""}
                                  alt={item.name}
                                  className="img-fluid rounded mb-2"
                                />
                                <h6 className="text-capitalize">{item.name}</h6>
                              </Col>
                            ))}
                          </Row>

                        </Container>

                      </div>

                    </UncontrolledDropdown>
                  </div>
                  <div ref={this.accessoriesRef} className="mega-menu-wrapper">
                    <UncontrolledDropdown
                      direction="down"
                      nav>
                      <DropdownToggle
                        onClick={() => this.toggleMegaAccessories()}
                        className="px-0"
                        caret
                        color="primary"
                        nav>
                        <span className="nav-link-inner--text">Wedding Accessories</span>
                      </DropdownToggle>
                      <div
                        className={`mega-menu p-4 shadow-lg ${this.state.megaAccessoriesOpen ? "show" : ""}`}
                      >

                        <Container fluid>
                          <Row>
                            <div className="col-12">
                              <h3 className="text-capitalize">Wedding Accessories</h3>
                            </div>
                            {this.state.accessoriesCategories.map((item, index) => (
                              <Col md="3" className="text-center mb-3 cursor-pointer" key={index} onClick={() => this.goToDetails(item.id, 'accessories')}>
                                <img
                                  src={baseUrl + item.thumb[0] || ""}
                                  alt={item.name}
                                  className="img-fluid rounded mb-2"
                                />
                                <h6 className="text-capitalize">{item.name}</h6>
                              </Col>
                            ))}
                          </Row>

                        </Container>

                      </div>

                    </UncontrolledDropdown>
                  </div>

                  {/* <UncontrolledDropdown
                    direction="down"
                    className={!checkMypackage ? "me-0" : ""}
                    nav>
                    <DropdownToggle
                      className="px-0 "
                      caret
                      color="primary"
                      nav>
                      <span className="nav-link-inner--text">Wedding Accessories</span>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem to="/accessories" tag={Link}>
                        All Wedding Accessories
                      </DropdownItem>
                      {this.state.accessoriesCategories.map((item, index) => {
                        return <DropdownItem className="text-capitalize" onClick={() => this.goToDetails(item.id, 'accessories')}>
                          {item.name}
                        </DropdownItem>
                      })}

                    </DropdownMenu>
                  </UncontrolledDropdown> */}
                  <div ref={this.blankRef} className="mega-menu-wrapper">
                    <UncontrolledDropdown
                      direction="down"
                      nav>
                      <DropdownToggle
                        onClick={() => this.toggleMegaBlank()}
                        className="px-0"
                        caret
                        color="primary"
                        nav>
                        <span className="nav-link-inner--text">Blank Item</span>
                      </DropdownToggle>
                      <div
                        className={`mega-menu p-4 shadow-lg ${this.state.megaBlankOpen ? "show" : ""}`}
                      >
                        <Container fluid>
                          <Row>
                            <div className="col-12">
                              <h3 className="text-capitalize">Blank Item</h3>
                            </div>
                            {this.state.giftItemsCategory.map((item, index) => (
                              <Col md="3" className="text-center mb-3 cursor-pointer" key={index} onClick={() => this.goToDetails(item.id, 'giftitems')}>
                                <img
                                  src={baseUrl + item.thumb[0] || ""}
                                  alt={item.name}
                                  className="img-fluid rounded mb-2"
                                />
                                <h6 className="text-capitalize">{item.name}</h6>
                              </Col>
                            ))}
                          </Row>

                        </Container>

                      </div>

                    </UncontrolledDropdown>
                  </div>
                  {checkMypackage &&
                    <NavItem className="me-0">
                      <NavLink exact to="/my-package">My Package</NavLink>
                    </NavItem>
                  }

                  <NavItem className="d-block d-lg-none d-xl-none">
                    <NavLink to="/testimonials">Testimonials</NavLink>
                  </NavItem>
                  <NavItem className="d-block d-lg-none d-xl-none">
                    <NavLink to="/stories">Stories</NavLink>
                  </NavItem>
                  <NavItem className="d-block d-lg-none d-xl-none">
                    <NavLink to="/contact-us">Contact Us</NavLink>
                  </NavItem>

                </Nav>

              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default DemoNavbar;
